import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { errorMessage } from '../helpers'

export const FETCH_DASHBOARD = 'FETCH_DASHBOARD'
export const FETCH_DASHBOARD_SUCCESS = 'FETCH_DASHBOARD_SUCCESS'
export const FETCH_DASHBOARD_FAILURE = 'FETCH_DASHBOARD_FAILURE'

export function loadDashboard(u) {
  return (dispatch) => {
    dispatch(fetchDashboard())
    axios({
      method: 'GET',
      url: URIS.dashboard,
      headers: loadHeaders()
    })
      .then((res) => {
        dispatch(fetchDashboardSuccess(res.data))
      })
      .catch((error) => {
        dispatch(fetchDashboardFailure(errorMessage(error)))
      })
  }
}

function fetchDashboard() {
  return {
    type: FETCH_DASHBOARD
  }
}

function fetchDashboardSuccess(payload) {
  return {
    type: FETCH_DASHBOARD_SUCCESS,
    payload
  }
}

function fetchDashboardFailure(payload) {
  return {
    type: FETCH_DASHBOARD_FAILURE,
    payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/Dashboard.js